export const environment = {
    isProduction: true,
    isWebComponent: false,
    serviceUrl: '',
    recaptcha: {
        siteKey: '6LfAChwTAAAAAI2MLaC4U5-_kExC4PVvq9D5P0r2',
    },
};
